const QUIZ_DATA = {
  bannerText: "Take the quiz for 45% off + free gifts",
  home: {
    title: "Is Fernes Right For You?",
    subtitle: "Choose the quiz that matches your primary health goal. It takes less than 2 minutes.",
    disclaimer: "Backed by peer-reviewed research · Free Shipping",
    quizzes: [
      { slug: "general",    cardTitle: "General Wellness",   cardDescription: "Discover how Fernes Colostrum supports your whole body — gut, immunity, energy, and more.",    iconFile: "icon-heart.svg" },
      { slug: "beauty",     cardTitle: "Skin, Hair & Nails", cardDescription: "Find out how colostrum's growth factors support beauty from the inside out.",                      iconFile: "icon-woman.svg" },
      { slug: "gut-health", cardTitle: "Gut Health",         cardDescription: "Learn how colostrum repairs and fortifies your gut lining — deeper than probiotics.",           iconFile: "icon-health.svg" },
      { slug: "recovery",   cardTitle: "Sports Recovery",    cardDescription: "See how colostrum supports muscle repair, gut protection, and immune defense for active women.", iconFile: "icon-flash.svg" },
      { slug: "bloating",   cardTitle: "Bloating Relief",    cardDescription: "Discover how colostrum addresses the root cause of chronic bloating — not just the symptoms.",   iconFile: "icon-wind.svg" },
      { slug: "glp1",       cardTitle: "GLP-1 Support",      cardDescription: "On Ozempic, Wegovy, or Mounjaro? Learn how colostrum supports your gut, muscle, and energy.",   iconFile: "icon-pill.svg" },
      { slug: "immunity",   cardTitle: "Immune Defense",     cardDescription: "Learn how colostrum's natural antibodies support year-round immune resilience — beyond vitamin C.", iconFile: "icon-shield.svg" }
    ]
  },
  redirectUrls: {
    "general":    "https://fernes.com/pages/welcome-email-sms",
    "beauty":     "https://fernes.com/pages/welcome-email-sms",
    "gut-health": "https://fernes.com/pages/welcome-email-sms",
    "recovery":   "https://fernes.com/pages/welcome-email-sms",
    "bloating":   "https://fernes.com/pages/welcome-email-sms",
    "glp1":       "https://fernes.com/pages/welcome-email-sms",
    "immunity":   "https://fernes.com/pages/welcome-email-sms"
  },
  quizzes: {
    general: {
      slug: "general",
      title: "Is Fernes Right For You?",
      steps: [
        {
          type: "question-single",
          headline: "How would you describe your overall wellness right now?",
          subtext: "Be honest — it helps us personalize your results.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "I feel great and want to stay ahead" },
            { label: "I'm okay but something feels off" },
            { label: "I'm struggling with energy, digestion, or immunity" },
            { label: "Not sure — I just want to feel better" }
          ]
        },
        {
          type: "question-multi",
          headline: "Which of these do you experience regularly?",
          subtext: "Select all that apply.",
          options: [
            { label: "Bloating or digestive discomfort" },
            { label: "Low energy or afternoon crashes" },
            { label: "Weakened immunity (getting sick often)" },
            { label: "Dull skin, thinning hair, or brittle nails" },
            { label: "Slow recovery after exercise" },
            { label: "Brain fog or trouble focusing" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Supports gut lining integrity and digestive comfort",
            "Delivers 400+ naturally occurring bioactives",
            "Promotes immune resilience year-round"
          ]
        },
        {
          type: "question-multi",
          headline: "Beyond general wellness, what matters most to you right now?",
          subtext: "Select all that apply.",
          options: [
            { label: "Gut health and digestion" },
            { label: "Skin, hair, and nail vitality" },
            { label: "Immune defense" },
            { label: "Fitness recovery" },
            { label: "Energy and focus" }
          ]
        },
        {
          type: "education",
          headline: "Fernes supports your whole body — from the inside out.",
          subtext: "First-day bovine colostrum delivers a complete matrix of bioactives that work across multiple systems.",
          proofCards: [
            { icon: "weight",   title: "IgG Antibodies",  description: "Supports gut barrier integrity and immune defense" },
            { icon: "shield", title: "Lactoferrin",     description: "Promotes skin vitality, hair growth, and muscle repair" },
            { icon: "scanning",      title: "Growth Factors",  description: "Supports cellular regeneration across all tissues" }
          ]
        },
        {
          type: "question-single",
          headline: "Have you tried colostrum before?",
          options: [
            { label: "Yes, and I loved it" },
            { label: "Yes, but I didn't notice results" },
            { label: "No, but I've been curious" },
            { label: "No, this is completely new to me" }
          ]
        },
        {
          type: "education",
          headline: "Not all colostrum is created equal. Fernes is first-day only.",
          subtext: "First-day colostrum contains the highest concentration of IgG, lactoferrin, and growth factors.",
          benefits: [
            { icon: "shield-circle",        title: "Highest Bioactive Concentration", description: "First-day harvest delivers peak levels of immune and growth factors" },
            { icon: "weight-circle",         title: "Grass-Fed, Pasture-Raised",        description: "Sourced from healthy cows — no hormones, no antibiotics" },
            { icon: "tested", title: "3rd-Party Tested",                 description: "Every batch tested for purity and potency" }
          ]
        },
        {
          type: "question-single",
          headline: "When choosing a supplement, how important is scientific research to you?",
          options: [
            { label: "Very important — I want to see the studies" },
            { label: "Somewhat important" },
            { label: "Not important" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Here's how Fernes stacks up.",
          comparisonHeaders: ["logo", "Most Others"],
          comparisonRows: [
            { feature: "First-day colostrum (highest bioactive concentration)", fernes: true, others: [false] },
            { feature: "400+ naturally occurring bioactives", fernes: true, others: [false] },
            { feature: "Grass-fed, pasture-raised sourcing", fernes: true, others: [false] },
            { feature: "No hormones, no antibiotics", fernes: true, others: [false] },
            { feature: "3rd-party tested for purity", fernes: true, others: [false] },
            { feature: "Unflavored — mixes into anything", fernes: true, others: [false] }
          ]
        },
        {
          type: "education",
          headline: "Colostrum is backed by decades of peer-reviewed research.",
          subtext: "Unlike most supplements, bovine colostrum has been studied extensively in clinical trials.",
          benefits: [
            { icon: "gut-health",    title: "Gut Health",      description: "A meta-analysis found that bovine colostrum significantly reduces intestinal permeability, supporting gut barrier integrity." },
            { icon: "immune",   title: "Immune Defense",  description: "A systematic review confirmed that colostrum's IgG antibodies and lactoferrin provide significant immune-modulating properties." },
            { icon: "recovery", title: "Recovery",        description: "A systematic review found that colostrum supplementation attenuates exercise-induced muscle damage markers." }
          ]
        },
        {
          type: "timeline",
          headline: "Fernes starts working from day one.",
          subtext: "Results build over time as colostrum supports your body's foundational systems.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "abdominal",      benefit: "Improved digestive comfort and reduced bloating*" },
            { timeframe: "Week 4",  icon: "skin-care", benefit: "Noticeable improvements in skin radiance and energy*" },
            { timeframe: "Month 3", icon: "cream",   benefit: "Stronger immune resilience and overall vitality*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum supplementation."
        },
        {
          type: "social-proof",
          headline: "Thousands of women trust Fernes every morning.",
          testimonials: [
            { quote: "I've tried every gut supplement out there. Fernes is the only one that actually made a difference. My bloating is gone.", name: "Sarah M.",   age: 34 },
            { quote: "My skin has never looked better. I stopped buying expensive serums — this does more from the inside.",                     name: "Jessica L.", age: 38 },
            { quote: "I used to get sick every time my kids brought something home. Three months on Fernes and I haven't missed a day.",          name: "Amanda R.",  age: 41 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    },

    beauty: {
      slug: "beauty",
      title: "Is Fernes Right For Your Beauty?",
      steps: [
        {
          type: "question-single",
          headline: "How would you describe your skin right now?",
          subtext: "Be honest — it helps us personalize your results.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "Glowing and healthy" },
            { label: "Okay, but I've lost some radiance" },
            { label: "Dull, dry, or showing signs of aging" },
            { label: "Breakout-prone or uneven" }
          ]
        },
        {
          type: "question-multi",
          headline: "Which beauty concerns bother you the most?",
          subtext: "Select all that apply.",
          options: [
            { label: "Fine lines or loss of firmness" },
            { label: "Dull, dehydrated skin" },
            { label: "Thinning hair or lack of volume" },
            { label: "Brittle or peeling nails" },
            { label: "Uneven skin tone or blemishes" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Supports collagen production with natural growth factors (EGF, TGF, IGF-1)",
            "Promotes hair follicle nourishment with lactoferrin",
            "Delivers deep cellular hydration for radiant skin"
          ]
        },
        {
          type: "question-single",
          headline: "What does your current beauty routine look like?",
          options: [
            { label: "Mostly topical — serums, creams, masks" },
            { label: "A mix of topical and supplements" },
            { label: "I take supplements but want something better" },
            { label: "I don't have a consistent routine" }
          ]
        },
        {
          type: "education",
          headline: "Topical products treat the surface. Fernes works at the cellular level.",
          subtext: "First-day colostrum delivers bioactives that support the structures beneath your skin, hair, and nails.",
          proofCards: [
            { icon: "snow", title: "EGF (Epidermal Growth Factor)", description: "Promotes cellular turnover and repair for smoother, firmer skin" },
            { icon: "scanning", title: "Lactoferrin",                    description: "Stimulates dermal papilla cell proliferation, supporting thicker hair growth" },
            { icon: "shield",      title: "IGF-1",                           description: "Supports tissue regeneration and structural integrity" }
          ]
        },
        {
          type: "question-single",
          headline: "Have you tried ingestible beauty supplements before?",
          options: [
            { label: "Yes — collagen, biotin, or similar" },
            { label: "Yes, but I didn't see results" },
            { label: "No, but I've been curious" },
            { label: "No, this is new to me" }
          ]
        },
        {
          type: "education",
          headline: "Why colostrum outperforms collagen supplements.",
          benefits: [
            { icon: "shield-circle", title: "Growth Factors, Not Just Raw Material", description: "Collagen provides building blocks — colostrum provides the signals that tell your body how to build collagen" },
            { icon: "weight-circle",    title: "Hair Follicle Support",                  description: "Lactoferrin has been shown to support hair follicle health at the cellular level" },
            { icon: "tested",   title: "400+ Bioactives",                        description: "Unlike biotin alone, colostrum delivers a complete matrix that works synergistically" }
          ]
        },
        {
          type: "question-single",
          headline: "How important is it that your beauty supplements are backed by research?",
          options: [
            { label: "Very important — show me the science" },
            { label: "Somewhat important" },
            { label: "Not important — I go by reviews" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Here's how Fernes compares to typical beauty supplements.",
          comparisonHeaders: ["logo", "Collagen", "Biotin"],
          comparisonRows: [
            { feature: "Contains natural growth factors (EGF, TGF, IGF-1)",     fernes: true, others: [false, false] },
            { feature: "Supports collagen production at the cellular level",   fernes: true, others: [false, false] },
            { feature: "Promotes hair follicle nourishment",                   fernes: true, others: [false, true]  },
            { feature: "Delivers 400+ bioactives for whole-body beauty",       fernes: true, others: [false, false] },
            { feature: "Supports gut health (the foundation of clear skin)",   fernes: true, others: [false, false] },
            { feature: "Grass-fed, no hormones, 3rd-party tested",             fernes: true, others: ["Varies", "Varies"] }
          ]
        },
        {
          type: "education",
          headline: "The science behind colostrum and beauty.",
          subtext: "Peer-reviewed research supports colostrum's role in skin, hair, and nail vitality.",
          benefits: [
            { icon: "skin",        title: "Skin Elasticity",  description: "Growth factors in colostrum (EGF, TGF) have been shown to promote cellular repair and help maintain skin elasticity and hydration." },
            { icon: "hair",   title: "Hair Growth",      description: "Lactoferrin has been demonstrated to stimulate the proliferation of dermal papilla cells, essential for healthy hair growth." },
            { icon: "skin-cell", title: "Cellular Renewal", description: "Colostrum's IGF-1 supports the growth and reconstruction of cells and tissues across skin, hair, and nails." }
          ]
        },
        {
          type: "timeline",
          headline: "Here's what to expect with Fernes.",
          subtext: "Beauty builds from the inside — results compound over time.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "skin-care",  benefit: "Improved skin hydration and a natural glow*" },
            { timeframe: "Week 4",  icon: "hair-2", benefit: "Noticeable improvements in hair thickness and nail strength*" },
            { timeframe: "Month 3", icon: "cream", benefit: "Visibly firmer skin, fuller hair, and stronger nails*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum bioactives."
        },
        {
          type: "social-proof",
          headline: "Women are choosing Fernes over their old beauty supplements.",
          testimonials: [
            { quote: "I spent hundreds on serums. Two months of Fernes and my skin looks better than it has in years. People keep asking what I changed.", name: "Lauren K.", age: 36 },
            { quote: "My hair was thinning after my second baby. Fernes brought it back — thicker and shinier than before.",                                name: "Megan T.",  age: 33 },
            { quote: "My nails used to peel constantly. After six weeks on Fernes, they're strong enough to grow out naturally.",                          name: "Rachel D.", age: 39 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    },

    "beauty-v2": {
      slug: "beauty-v2",
      title: "Is Fernes Right For Your Beauty?",
      steps: [
        {
          type: "question-multi",
          headline: "Which beauty concerns bother you the most?",
          subtext: "Select all that apply.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "Fine lines or loss of firmness" },
            { label: "Dull, dehydrated skin" },
            { label: "Thinning hair or lack of volume" },
            { label: "Brittle or peeling nails" },
            { label: "Uneven skin tone or blemishes" }
          ]
        },
        {
          type: "question-single",
          headline: "How would you describe your skin right now?",
          subtext: "Be honest — it helps us personalize your results.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "Glowing and healthy" },
            { label: "Okay, but I've lost some radiance" },
            { label: "Dull, dry, or showing signs of aging" },
            { label: "Breakout-prone or uneven" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Supports collagen production with natural growth factors (EGF, TGF, IGF-1)",
            "Promotes hair follicle nourishment with lactoferrin",
            "Delivers deep cellular hydration for radiant skin"
          ]
        },
        {
          type: "question-single",
          headline: "What does your current beauty routine look like?",
          options: [
            { label: "Mostly topical — serums, creams, masks" },
            { label: "A mix of topical and supplements" },
            { label: "I take supplements but want something better" },
            { label: "I don't have a consistent routine" }
          ]
        },
        {
          type: "education",
          headline: "Topical products treat the surface. Fernes works at the cellular level.",
          subtext: "First-day colostrum delivers bioactives that support the structures beneath your skin, hair, and nails.",
          proofCards: [
            { icon: "snow", title: "EGF (Epidermal Growth Factor)", description: "Promotes cellular turnover and repair for smoother, firmer skin" },
            { icon: "scanning", title: "Lactoferrin",                    description: "Stimulates dermal papilla cell proliferation, supporting thicker hair growth" },
            { icon: "shield",      title: "IGF-1",                           description: "Supports tissue regeneration and structural integrity" }
          ]
        },
        {
          type: "question-single",
          headline: "Have you tried ingestible beauty supplements before?",
          options: [
            { label: "Yes — collagen, biotin, or similar" },
            { label: "Yes, but I didn't see results" },
            { label: "No, but I've been curious" },
            { label: "No, this is new to me" }
          ]
        },
        {
          type: "education",
          headline: "Why colostrum outperforms collagen supplements.",
          benefits: [
            { icon: "shield-circle", title: "Growth Factors, Not Just Raw Material", description: "Collagen provides building blocks — colostrum provides the signals that tell your body how to build collagen" },
            { icon: "weight-circle",    title: "Hair Follicle Support",                  description: "Lactoferrin has been shown to support hair follicle health at the cellular level" },
            { icon: "tested",   title: "400+ Bioactives",                        description: "Unlike biotin alone, colostrum delivers a complete matrix that works synergistically" }
          ]
        },
        {
          type: "question-single",
          headline: "How important is it that your beauty supplements are backed by research?",
          options: [
            { label: "Very important — show me the science" },
            { label: "Somewhat important" },
            { label: "Not important — I go by reviews" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Here's how Fernes compares to typical beauty supplements.",
          comparisonHeaders: ["logo", "Collagen", "Biotin"],
          comparisonRows: [
            { feature: "Contains natural growth factors (EGF, TGF, IGF-1)",     fernes: true, others: [false, false] },
            { feature: "Supports collagen production at the cellular level",   fernes: true, others: [false, false] },
            { feature: "Promotes hair follicle nourishment",                   fernes: true, others: [false, true]  },
            { feature: "Delivers 400+ bioactives for whole-body beauty",       fernes: true, others: [false, false] },
            { feature: "Supports gut health (the foundation of clear skin)",   fernes: true, others: [false, false] },
            { feature: "Grass-fed, no hormones, 3rd-party tested",             fernes: true, others: ["Varies", "Varies"] }
          ]
        },
        {
          type: "education",
          headline: "The science behind colostrum and beauty.",
          subtext: "Peer-reviewed research supports colostrum's role in skin, hair, and nail vitality.",
          benefits: [
            { icon: "skin",        title: "Skin Elasticity",  description: "Growth factors in colostrum (EGF, TGF) have been shown to promote cellular repair and help maintain skin elasticity and hydration." },
            { icon: "hair",   title: "Hair Growth",      description: "Lactoferrin has been demonstrated to stimulate the proliferation of dermal papilla cells, essential for healthy hair growth." },
            { icon: "skin-cell", title: "Cellular Renewal", description: "Colostrum's IGF-1 supports the growth and reconstruction of cells and tissues across skin, hair, and nails." }
          ]
        },
        {
          type: "timeline",
          headline: "Here's what to expect with Fernes.",
          subtext: "Beauty builds from the inside — results compound over time.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "skin-care",  benefit: "Improved skin hydration and a natural glow*" },
            { timeframe: "Week 4",  icon: "hair-2", benefit: "Noticeable improvements in hair thickness and nail strength*" },
            { timeframe: "Month 3", icon: "cream", benefit: "Visibly firmer skin, fuller hair, and stronger nails*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum bioactives."
        },
        {
          type: "social-proof",
          headline: "Women are choosing Fernes over their old beauty supplements.",
          testimonials: [
            { quote: "I spent hundreds on serums. Two months of Fernes and my skin looks better than it has in years. People keep asking what I changed.", name: "Lauren K.", age: 36 },
            { quote: "My hair was thinning after my second baby. Fernes brought it back — thicker and shinier than before.",                                name: "Megan T.",  age: 33 },
            { quote: "My nails used to peel constantly. After six weeks on Fernes, they're strong enough to grow out naturally.",                          name: "Rachel D.", age: 39 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    },

    "gut-health": {
      slug: "gut-health",
      title: "Is Fernes Right For Your Gut?",
      steps: [
        {
          type: "question-single",
          headline: "How often do you experience digestive discomfort?",
          subtext: "Bloating, gas, irregularity — it all counts.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "Daily" },
            { label: "A few times a week" },
            { label: "Occasionally" },
            { label: "Rarely" }
          ]
        },
        {
          type: "question-multi",
          headline: "Which gut issues bother you the most?",
          subtext: "Select all that apply.",
          options: [
            { label: "Bloating or gas after meals" },
            { label: "Constipation or irregularity" },
            { label: "Stomach cramps or discomfort" },
            { label: "Food sensitivities" },
            { label: "Feeling sluggish after eating" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Supports and fortifies the gut lining with IgG antibodies",
            "Nourishes the microbiome with natural prebiotics and peptides",
            "Promotes digestive comfort and daily regularity"
          ]
        },
        {
          type: "question-single",
          headline: "What have you already tried for gut health?",
          options: [
            { label: "Probiotics" },
            { label: "Fiber supplements" },
            { label: "Elimination diets" },
            { label: "Prescription medication" },
            { label: "Nothing yet — I'm just starting" }
          ]
        },
        {
          type: "education",
          headline: "Probiotics add bacteria. Fernes repairs the environment they live in.",
          subtext: "Your gut lining is the foundation. Without a strong barrier, even the best probiotics can't do their job.",
          proofCards: [
            { icon: "shield", title: "IgG Antibodies",              description: "Neutralize endotoxins and support gut lining integrity" },
            { icon: "scanning",  title: "Lactoferrin",                 description: "Promotes growth of beneficial bacteria while inhibiting harmful pathogens" },
            { icon: "weight",    title: "Growth Factors (IGF-1, TGF)", description: "Stimulate cellular regeneration of the intestinal epithelium" }
          ]
        },
        {
          type: "question-single",
          headline: "Do you currently take a daily gut health supplement?",
          options: [
            { label: "Yes — probiotics or similar" },
            { label: "Yes, but it's not working well" },
            { label: "No, but I want to start" },
            { label: "No, I rely on diet alone" }
          ]
        },
        {
          type: "education",
          headline: "Why colostrum works when probiotics alone don't.",
          benefits: [
            { icon: "shield-circle",      title: "Gut Barrier First",    description: "Probiotics add beneficial bacteria, but if your gut lining is compromised, they pass right through" },
            { icon: "tested",        title: "Clinically Proven",    description: "Clinical evidence shows bovine colostrum significantly reduces intestinal permeability" },
            { icon: "weight-circle", title: "Works With Your Stack", description: "Fernes works with your probiotics — it creates the environment where they can thrive" }
          ]
        },
        {
          type: "question-single",
          headline: "How important is clinical research when choosing a gut supplement?",
          options: [
            { label: "Very important — I need to see proof" },
            { label: "Somewhat important" },
            { label: "Not important — I trust reviews" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Here's how Fernes compares to typical gut supplements.",
          comparisonHeaders: ["logo", "Probiotics", "Fiber"],
          comparisonRows: [
            { feature: "Repairs and fortifies the gut lining",            fernes: true, others: [false, false] },
            { feature: "Contains IgG antibodies for endotoxin defense",   fernes: true, others: [false, false] },
            { feature: "Nourishes the microbiome naturally",              fernes: true, others: [true, true]   },
            { feature: "Delivers 400+ bioactives for whole-body support", fernes: true, others: [false, false] },
            { feature: "Supports immune function via the gut",            fernes: true, others: [true, false]  },
            { feature: "Grass-fed, no hormones, 3rd-party tested",        fernes: true, others: ["Varies", "Varies"] }
          ]
        },
        {
          type: "education",
          headline: "The science behind colostrum and gut health.",
          subtext: "Bovine colostrum is one of the most clinically studied natural gut-support compounds.",
          benefits: [
            { icon: "gut-health",  title: "Gut Permeability",   description: "A meta-analysis of randomized clinical trials found that bovine colostrum significantly reduces intestinal permeability, a key marker of 'leaky gut'." },
            { icon: "immune", title: "Endotoxin Defense",  description: "A systematic review confirmed that colostrum's IgG antibodies have direct endotoxin-neutralizing effects throughout the alimentary tract." },
            { icon: "skin-cell",    title: "Microbiome Support", description: "Research shows that colostrum's prebiotics and peptides create an optimal environment for beneficial gut bacteria to flourish." }
          ]
        },
        {
          type: "timeline",
          headline: "Here's what to expect with Fernes.",
          subtext: "Gut repair is a process — results build as your gut lining strengthens.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "abdominal",          benefit: "Reduced bloating and improved digestive comfort*" },
            { timeframe: "Week 4",  icon: "bloating", benefit: "More consistent daily regularity and less food sensitivity*" },
            { timeframe: "Month 3", icon: "cream",       benefit: "Stronger gut barrier, improved nutrient absorption, and immune resilience*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum supplementation."
        },
        {
          type: "social-proof",
          headline: "Women are finally finding gut relief with Fernes.",
          testimonials: [
            { quote: "I've been on probiotics for years and still bloated every night. Two weeks on Fernes and I finally feel flat after dinner.",                   name: "Nicole P.",    age: 37 },
            { quote: "I used to dread eating out because of how my stomach would react. Fernes changed that completely.",                                             name: "Danielle S.",  age: 35 },
            { quote: "My doctor told me I had increased intestinal permeability. After three months of Fernes, my follow-up labs improved significantly.",           name: "Christina W.", age: 42 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    },

    recovery: {
      slug: "recovery",
      title: "Is Fernes Right For Your Recovery?",
      steps: [
        {
          type: "question-single",
          headline: "How often do you work out?",
          subtext: "Any movement counts — gym, running, yoga, pilates.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "5+ times a week" },
            { label: "3–4 times a week" },
            { label: "1–2 times a week" },
            { label: "I'm trying to get back into it" }
          ]
        },
        {
          type: "question-multi",
          headline: "What's holding back your fitness progress?",
          subtext: "Select all that apply.",
          options: [
            { label: "Slow recovery between workouts" },
            { label: "Muscle soreness that lasts too long" },
            { label: "Low energy or fatigue during exercise" },
            { label: "Getting sick and missing training days" },
            { label: "Joint discomfort" },
            { label: "Digestive issues after intense workouts" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Supports muscle recovery with natural growth factors (IGF-1)",
            "Protects the gut lining from exercise-induced stress",
            "Promotes immune resilience so you never miss a training day"
          ]
        },
        {
          type: "question-multi",
          headline: "Beyond recovery, what else matters to you?",
          subtext: "Select all that apply.",
          options: [
            { label: "Building lean muscle" },
            { label: "Immune defense (staying healthy year-round)" },
            { label: "Gut health and digestion" },
            { label: "Energy and endurance" },
            { label: "Skin and hair vitality" }
          ]
        },
        {
          type: "education",
          headline: "Fernes supports recovery at the cellular level — not just the surface.",
          subtext: "First-day colostrum delivers a complete matrix of bioactives that address the root causes of slow recovery.",
          proofCards: [
            { icon: "weight", title: "IGF-1",          description: "Supports muscle repair and attenuates exercise-induced damage markers" },
            { icon: "shield",   title: "IgG Antibodies", description: "Protects the gut lining from exercise-induced permeability ('runner's gut')" },
            { icon: "scanning",    title: "Lactoferrin",    description: "Supports immune defense during periods of intense training" }
          ]
        },
        {
          type: "question-single",
          headline: "What recovery supplements do you currently use?",
          options: [
            { label: "Protein powder only" },
            { label: "Protein + creatine or BCAAs" },
            { label: "A full recovery stack (multiple supplements)" },
            { label: "Nothing specific — just food and rest" }
          ]
        },
        {
          type: "education",
          headline: "Protein rebuilds muscle. Fernes rebuilds everything else.",
          benefits: [
            { icon: "shield-circle",    title: "Growth Factor Acceleration", description: "Protein provides amino acids — colostrum provides the growth factors that accelerate the repair process" },
            { icon: "gut-protection", title: "Gut Protection",             description: "Intense exercise increases gut permeability by up to 250% — colostrum is clinically shown to prevent this" },
            { icon: "tested", title: "400+ Bioactives",            description: "Unlike single-ingredient supplements, colostrum supports muscle, gut, and immune recovery simultaneously" }
          ]
        },
        {
          type: "question-single",
          headline: "How important is it that your supplements are backed by sports science?",
          options: [
            { label: "Very important — I want clinical evidence" },
            { label: "Somewhat important" },
            { label: "Not important — I go by results" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Here's how Fernes compares to typical recovery supplements.",
          comparisonHeaders: ["logo", "Protein", "BCAAs"],
          comparisonRows: [
            { feature: "Contains natural growth factors (IGF-1)",          fernes: true, others: [false, false] },
            { feature: "Protects gut lining during intense exercise",      fernes: true, others: [false, false] },
            { feature: "Supports immune defense during training",          fernes: true, others: [false, false] },
            { feature: "Delivers 400+ bioactives for whole-body recovery", fernes: true, others: [false, false] },
            { feature: "Attenuates muscle-damage markers",                 fernes: true, others: [true, true]   },
            { feature: "Grass-fed, no hormones, 3rd-party tested",         fernes: true, others: ["Varies", "Varies"] }
          ]
        },
        {
          type: "education",
          headline: "The science behind colostrum and athletic recovery.",
          subtext: "Bovine colostrum has been studied extensively in sports science and exercise physiology.",
          benefits: [
            { icon: "recovery", title: "Muscle Recovery",            description: "A systematic review found that colostrum supplementation attenuates exercise-induced muscle damage markers, including creatine kinase." },
            { icon: "gut-health",    title: "Exercise-Induced Gut Stress", description: "A meta-analysis demonstrated that bovine colostrum significantly reduces intestinal permeability caused by intense exercise." },
            { icon: "immune",   title: "Immune Protection",          description: "Research shows that colostrum helps maintain immune function during heavy training, reducing upper respiratory illness." }
          ]
        },
        {
          type: "timeline",
          headline: "Here's what to expect with Fernes.",
          subtext: "Recovery improvements build as colostrum supports your body's repair systems.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "bolt", benefit: "Reduced post-workout soreness and faster bounce-back*" },
            { timeframe: "Week 4",  icon: "abdominal",    benefit: "Improved digestive comfort during and after intense training*" },
            { timeframe: "Month 3", icon: "cream",   benefit: "Stronger immune resilience and consistent training without sick days*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum supplementation in athletes."
        },
        {
          type: "social-proof",
          headline: "Active women are adding Fernes to their recovery stack.",
          testimonials: [
            { quote: "I do CrossFit five days a week. Since adding Fernes, my recovery between sessions has been noticeably faster.", name: "Brittany H.",  age: 31 },
            { quote: "I used to get stomach cramps during long runs. Fernes completely eliminated that.",                              name: "Kayla M.",     age: 34 },
            { quote: "I haven't missed a workout due to illness in four months. That's never happened before.",                        name: "Stephanie R.", age: 38 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    },

    bloating: {
      slug: "bloating",
      title: "Is Fernes Right For Your Bloating?",
      steps: [
        {
          type: "question-single",
          headline: "How often do you feel bloated?",
          subtext: "That uncomfortable, puffy feeling — especially after meals.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "Every day" },
            { label: "A few times a week" },
            { label: "A few times a month" },
            { label: "Rarely" }
          ]
        },
        {
          type: "question-multi",
          headline: "What does your bloating look like?",
          subtext: "Select all that apply.",
          options: [
            { label: "I wake up flat but bloat by evening" },
            { label: "I bloat immediately after eating" },
            { label: "I feel gassy and uncomfortable most of the day" },
            { label: "I also deal with constipation or irregularity" },
            { label: "Certain foods trigger it but I can't figure out which ones" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Supports gut lining integrity to reduce bloating triggers",
            "Neutralizes endotoxins that cause gas and inflammation",
            "Promotes daily regularity without harsh laxatives"
          ]
        },
        {
          type: "question-single",
          headline: "What have you already tried for bloating?",
          options: [
            { label: "Probiotics" },
            { label: "Digestive enzymes" },
            { label: "Elimination diets (low FODMAP, etc.)" },
            { label: "Over-the-counter remedies (Gas-X, etc.)" },
            { label: "Nothing yet — I'm just starting to address it" }
          ]
        },
        {
          type: "education",
          headline: "Most bloating remedies treat symptoms. Fernes addresses the cause.",
          subtext: "Bloating often starts with a compromised gut lining. When the barrier is weak, endotoxins leak through and trigger inflammation, gas, and discomfort.",
          proofCards: [
            { icon: "shield", title: "IgG Antibodies",               description: "Directly neutralize endotoxins in the gut, reducing the inflammatory trigger behind bloating" },
            { icon: "weight",    title: "Growth Factors (IGF-1, TGF)",  description: "Stimulate repair and regeneration of the intestinal epithelium, sealing the barrier" },
            { icon: "scanning",  title: "Prebiotics & Peptides",        description: "Nourish beneficial bacteria and promote a balanced gut ecosystem" }
          ]
        },
        {
          type: "question-single",
          headline: "How regular are your bowel movements?",
          options: [
            { label: "Very regular — daily and comfortable" },
            { label: "Somewhat regular — but not consistent" },
            { label: "Irregular — I often skip days" },
            { label: "I deal with both constipation and urgency" }
          ]
        },
        {
          type: "education",
          headline: "Why colostrum works when probiotics and enzymes don't.",
          benefits: [
            { icon: "symptoms",      title: "Root Cause, Not Symptoms",        description: "Probiotics add bacteria, but if your gut lining is compromised, the root cause of bloating remains" },
            { icon: "gut-protection",        title: "Clinically Proven Barrier Repair", description: "Colostrum is the only natural compound clinically shown to reduce intestinal permeability" },
            { icon: "weight-circle", title: "Works With Your Stack",           description: "Fernes works alongside your existing supplements to fix the foundation" }
          ]
        },
        {
          type: "question-single",
          headline: "How important is scientific evidence when choosing a bloating supplement?",
          options: [
            { label: "Very important — I'm tired of things that don't work" },
            { label: "Somewhat important" },
            { label: "Not important — I just want relief" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Here's how Fernes compares to typical bloating remedies.",
          comparisonHeaders: ["logo", "Probiotics", "Enzymes", "Gas-X"],
          comparisonRows: [
            { feature: "Repairs the gut lining (root cause)",          fernes: true, others: [false, false, false] },
            { feature: "Neutralizes endotoxins that trigger bloating", fernes: true, others: [false, false, false] },
            { feature: "Supports daily regularity",                    fernes: true, others: [true, false, false]  },
            { feature: "Nourishes the microbiome",                     fernes: true, others: [true, false, false]  },
            { feature: "Provides whole-body immune support",           fernes: true, others: [true, false, false]  },
            { feature: "No side effects, no dependency",               fernes: true, others: [true, true, false]   }
          ]
        },
        {
          type: "education",
          headline: "The science behind colostrum and bloating relief.",
          subtext: "Chronic bloating is often linked to increased intestinal permeability. Here's what the research says.",
          benefits: [
            { icon: "gut-health",  title: "Gut Permeability",      description: "A meta-analysis of randomized clinical trials found that bovine colostrum significantly reduces intestinal permeability, the key driver of chronic bloating." },
            { icon: "skin-cell", title: "Endotoxin Neutralization", description: "Research confirms that colostrum's IgG antibodies have direct endotoxin-neutralizing effects throughout the digestive tract." },
            { icon: "immune",    title: "Digestive Comfort",     description: "A systematic review found that colostrum supplementation supports overall gastrointestinal health, including improved bowel regularity." }
          ]
        },
        {
          type: "timeline",
          headline: "Here's what to expect with Fernes.",
          subtext: "Bloating relief starts quickly — lasting results build as your gut lining heals.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "abdominal",          benefit: "Noticeably reduced bloating and gas, especially after meals*" },
            { timeframe: "Week 4",  icon: "bloating", benefit: "Improved daily regularity and less food sensitivity*" },
            { timeframe: "Month 3", icon: "cream",       benefit: "Stronger gut barrier, consistent comfort, and reduced inflammation*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum supplementation."
        },
        {
          type: "social-proof",
          headline: "Women are finally beating the bloat with Fernes.",
          testimonials: [
            { quote: "I've been bloated every single day for three years. After two weeks on Fernes, I can finally button my jeans comfortably at night.", name: "Ashley B.",   age: 36 },
            { quote: "I tried every probiotic on the market. Fernes is the first thing that actually addressed the root cause. My bloating is 90% gone.",  name: "Courtney M.", age: 33 },
            { quote: "I used to avoid eating out because I knew I'd bloat. Now I eat what I want and feel fine. Fernes changed my relationship with food.", name: "Samantha K.", age: 40 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    },

    glp1: {
      slug: "glp1",
      title: "Is Fernes Right For GLP-1 Users?",
      steps: [
        {
          type: "question-single",
          headline: "Are you currently taking a GLP-1 medication?",
          subtext: "Ozempic, Wegovy, Mounjaro, Zepbound, or similar.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "Yes, I'm currently on one" },
            { label: "I'm about to start" },
            { label: "I recently stopped" },
            { label: "I'm considering it" }
          ]
        },
        {
          type: "question-multi",
          headline: "Which side effects have you experienced on your GLP-1 journey?",
          subtext: "Select all that apply. Up to 50% of GLP-1 users report GI side effects.",
          options: [
            { label: "Nausea or acid reflux" },
            { label: "Bloating or gas" },
            { label: "Constipation or irregular digestion" },
            { label: "Fatigue or low energy" },
            { label: "Muscle loss or weakness" },
            { label: "Skin changes or hair thinning" },
            { label: "None so far" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Supports digestive comfort and reduces GI side effects",
            "Helps preserve lean muscle during caloric restriction",
            "Delivers 400+ bioactives including IgG, lactoferrin, and growth factors"
          ]
        },
        {
          type: "question-multi",
          headline: "Beyond GI comfort, what matters most to you right now?",
          subtext: "Select all that apply.",
          options: [
            { label: "Preserving lean muscle mass" },
            { label: "Keeping my immune system strong" },
            { label: "Maintaining skin and hair health" },
            { label: "Sustaining energy throughout the day" },
            { label: "Supporting gut health long-term" }
          ]
        },
        {
          type: "education",
          headline: "Why GLP-1 users are turning to colostrum.",
          subtext: "A pilot study found that all symptomatic GLP-1 users reported notable improvement after adding bovine colostrum to their regimen.",
          proofCards: [
            { icon: "shield",   title: "IgG Antibodies (600mg)",       description: "Support gut barrier integrity and help reduce GI side effects common with GLP-1 medications" },
            { icon: "scanning", title: "Lactoferrin & PRPs",            description: "Promote immune balance and help your body adapt during rapid metabolic changes" },
            { icon: "weight",      title: "Growth Factors (IGF-1, TGF-β)", description: "Support lean muscle preservation and skin vitality during caloric restriction" }
          ]
        },
        {
          type: "question-single",
          headline: "Have you tried any supplements to manage GLP-1 side effects?",
          options: [
            { label: "Yes — probiotics" },
            { label: "Yes — fiber or digestive enzymes" },
            { label: "Yes — protein or collagen" },
            { label: "No, I haven't tried anything yet" }
          ]
        },
        {
          type: "education",
          headline: "Colostrum addresses the root cause — not just the symptoms.",
          subtext: "Unlike probiotics or fiber that target one issue, colostrum works across your entire gut-immune-muscle axis.",
          benefits: [
            { icon: "gut-protection",    title: "Gut Lining Repair",      description: "IgG antibodies seal and strengthen the intestinal barrier that GLP-1 medications can stress" },
            { icon: "shield-circle", title: "Muscle Preservation",    description: "Growth factors like IGF-1 support lean mass retention during the caloric deficit GLP-1 creates" },
            { icon: "symptoms",     title: "Whole-Body Nourishment", description: "400+ bioactives deliver the micronutrients your body misses when appetite is suppressed" }
          ]
        },
        {
          type: "question-single",
          headline: "How important is it that your supplements are backed by clinical research?",
          options: [
            { label: "Very important — I want to see the studies" },
            { label: "Somewhat important" },
            { label: "Not a priority" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Here's how Fernes compares to common GLP-1 support supplements.",
          comparisonHeaders: ["logo", "Probiotics", "Fiber"],
          comparisonRows: [
            { feature: "Supports gut lining integrity (IgG)",    fernes: true, others: [false, false] },
            { feature: "Preserves lean muscle (growth factors)", fernes: true, others: [false, false] },
            { feature: "Reduces GI side effects",                fernes: true, others: ["Partial", "Partial"] },
            { feature: "Supports immune resilience",             fernes: true, others: ["Partial", false] },
            { feature: "Promotes skin and hair vitality",        fernes: true, others: [false, false] },
            { feature: "400+ naturally occurring bioactives",    fernes: true, others: [false, false] }
          ]
        },
        {
          type: "education",
          headline: "The research behind colostrum and GLP-1 support.",
          subtext: "Peer-reviewed studies confirm what thousands of users already know.",
          benefits: [
            { icon: "immune",    title: "GI Symptom Relief",      description: "A pilot study published in Nutrients found that all 10 symptomatic GLP-1 users reported notable improvement after bovine colostrum supplementation. (Oken et al., 2024)" },
            { icon: "gut-health",   title: "Gut Barrier Support",    description: "A systematic review found that bovine colostrum significantly reduces intestinal permeability, supporting the gut lining integrity GLP-1 can compromise. (Dziewiecka et al., 2022)" },
            { icon: "recovery", title: "Lean Mass Preservation", description: "Clinical trials show bovine colostrum supplementation supports lean tissue maintenance, critical during the caloric restriction GLP-1 medications create. (Davison, 2021)" }
          ]
        },
        {
          type: "timeline",
          headline: "What to expect on Fernes + GLP-1.",
          subtext: "Results build over time as colostrum supports your body through every phase.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "abdominal",      benefit: "Reduced nausea, bloating, and digestive discomfort*" },
            { timeframe: "Week 4",  icon: "bolt", benefit: "Improved energy, skin clarity, and more regular digestion*" },
            { timeframe: "Month 3", icon: "cream",   benefit: "Stronger immune resilience, preserved muscle mass, and whole-body balance*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum supplementation."
        },
        {
          type: "social-proof",
          headline: "GLP-1 users are choosing Fernes for a reason.",
          testimonials: [
            { quote: "I almost quit Ozempic because of the nausea. My doctor suggested colostrum and within a week the GI issues were manageable. Fernes lets me stay on my medication.", name: "Rachel T.",    age: 42 },
            { quote: "I was losing weight but also losing my hair and muscle tone. Three months on Fernes and my hair stopped falling out, my energy is back, and I kept the weight off.", name: "Danielle K.",  age: 38 },
            { quote: "The bloating and constipation on Mounjaro were unbearable. Fernes was the missing piece — my digestion is smoother than it's been in years.",                         name: "Christina M.", age: 45 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    },

    immunity: {
      slug: "immunity",
      title: "Is Fernes Right For Your Immune Health?",
      steps: [
        {
          type: "question-single",
          headline: "How often do you get sick in a typical year?",
          subtext: "Colds, flu, respiratory infections — anything that slows you down.",
          bannerText: "Complete the quiz for 45% off + free gifts",
          options: [
            { label: "Rarely — maybe once a year" },
            { label: "A few times a year" },
            { label: "Frequently — every season" },
            { label: "I feel like I'm always fighting something" }
          ]
        },
        {
          type: "question-multi",
          headline: "Which of these immune concerns do you relate to?",
          subtext: "Select all that apply.",
          options: [
            { label: "I catch every cold my kids bring home" },
            { label: "I feel run down even when I'm not sick" },
            { label: "My recovery from illness takes too long" },
            { label: "I get sick after travel or stressful periods" },
            { label: "Seasonal changes always hit me hard" },
            { label: "I worry about my immune health as I age" }
          ]
        },
        {
          type: "education",
          headline: "Meet Fernes Colostrum. The foundational supplement your body ==has been missing.==",
          checkmarks: [
            "Delivers concentrated IgG antibodies that bind human pathogens",
            "Supports a 32% reduction in respiratory infection risk (meta-analysis of RCTs)",
            "Contains 400+ bioactives working across the gut-immune axis"
          ]
        },
        {
          type: "question-multi",
          headline: "Besides immune defense, what else matters to you?",
          subtext: "Select all that apply.",
          options: [
            { label: "Gut health and digestion" },
            { label: "Energy and focus" },
            { label: "Skin, hair, and nail vitality" },
            { label: "Fitness recovery" },
            { label: "Healthy aging" }
          ]
        },
        {
          type: "education",
          headline: "Colostrum delivers a triple-layer immune defense.",
          subtext: "Three key bioactives work together to protect your body at every level.",
          proofCards: [
            { icon: "shield", title: "IgG Antibodies (20–150 mg/mL)",  description: "Bind and neutralize bacteria, viruses, and toxins in the bloodstream" },
            { icon: "scanning",   title: "Lactoferrin (1.5–5 mg/mL)",       description: "Starves harmful bacteria by binding iron; antiviral and antifungal properties" },
            { icon: "weight",    title: "Proline-Rich Polypeptides",       description: "Modulate immune response — boost when needed, calm when overreacting" }
          ]
        },
        {
          type: "question-single",
          headline: "What do you currently take for immune support?",
          options: [
            { label: "Vitamin C, zinc, or elderberry" },
            { label: "A multivitamin" },
            { label: "Probiotics" },
            { label: "Nothing specific" }
          ]
        },
        {
          type: "education",
          headline: "Why colostrum outperforms single-ingredient immune supplements.",
          subtext: "Most immune supplements deliver one isolated nutrient. Colostrum delivers a complete immune system in a scoop.",
          benefits: [
            { icon: "shield-circle",        title: "Whole-System Approach",  description: "400+ bioactives evolved to protect a newborn's entire immune system" },
            { icon: "gut-protection",        title: "Gut-Immune Connection",  description: "70% of your immune system lives in your gut — colostrum strengthens the barrier" },
            { icon: "tested", title: "Clinically Studied",     description: "Meta-analysis of RCTs confirms 32% reduction in upper respiratory infection risk" }
          ]
        },
        {
          type: "question-single",
          headline: "How important is clinical research when choosing an immune supplement?",
          options: [
            { label: "Very important — I want peer-reviewed evidence" },
            { label: "Somewhat important" },
            { label: "Not important — I go by how I feel" },
            { label: "Not sure" }
          ]
        },
        {
          type: "comparison",
          headline: "Fernes vs. typical immune supplements.",
          comparisonHeaders: ["Fernes Colostrum", "Vitamin C", "Elderberry"],
          comparisonRows: [
            { feature: "Natural IgG antibodies that bind pathogens",      fernes: true, others: [false, false] },
            { feature: "Lactoferrin (antimicrobial, antiviral)",           fernes: true, others: [false, false] },
            { feature: "Supports gut barrier (70% of immune system)",      fernes: true, others: [false, false] },
            { feature: "400+ bioactives working synergistically",          fernes: true, others: [false, false] },
            { feature: "Meta-analysis proven (32% URTI reduction)",        fernes: true, others: [false, false] },
            { feature: "Supports skin, hair, muscle, and energy too",      fernes: true, others: [false, false] }
          ]
        },
        {
          type: "education",
          headline: "Backed by peer-reviewed clinical research.",
          subtext: "Colostrum's immune benefits are confirmed across multiple study types.",
          benefits: [
            { icon: "immune",   title: "32% Infection Reduction", description: "A meta-analysis of RCTs found colostrum reduces upper respiratory infection risk by 32% (RR = 0.68, p = 0.001)." },
            { icon: "anti-bodies",    title: "94% IgG Increase",        description: "A 6-month double-blind crossover trial showed colostrum increased IgG antibody levels by up to 94% vs. placebo." },
            { icon: "gut-health", title: "79% sIgA Boost",           description: "A 12-week RCT found colostrum increased secretory IgA — the primary mucosal antibody — by 79%." }
          ]
        },
        {
          type: "timeline",
          headline: "Your immune resilience builds over time.",
          subtext: "Colostrum starts supporting your immune system from day one.",
          timelineItems: [
            { timeframe: "Week 1",  icon: "bloating",   benefit: "IgG antibodies begin supporting gut barrier and pathogen defense*" },
            { timeframe: "Week 4",  icon: "cream", benefit: "Mucosal immunity strengthens; fewer seasonal symptoms*" },
            { timeframe: "Month 3", icon: "bolt",      benefit: "Year-round resilience — fewer sick days, faster recovery*" }
          ],
          disclaimer: "*Individual results may vary. Benefits supported by peer-reviewed clinical research on bovine colostrum supplementation."
        },
        {
          type: "social-proof",
          headline: "Thousands of women trust Fernes for daily immune defense.",
          testimonials: [
            { quote: "I used to catch every cold my kids brought home from school. Three months on Fernes and I haven't missed a day of work.",                    name: "Amanda R.",   age: 41 },
            { quote: "I travel constantly for work and always got sick after flights. Since starting Fernes, I've made it through two international trips without a sniffle.", name: "Rachel K.",   age: 37 },
            { quote: "I was skeptical — I've tried every immune supplement. Fernes is the first one where I actually noticed I stopped getting sick.",              name: "Danielle P.", age: 44 }
          ]
        },
        {
          type: "email-capture",
          headline: "Unlock 45% off + free gifts with your email."
        }
      ]
    }
  }
};
